"use client";

import { c as _c } from "react/compiler-runtime";
import { Locale } from "@/types/locale";
import { PropsWithClassName } from "@/types/ui";
import React, { FC, useTransition } from "react";
import { Button } from "@components/ui/button";
import { setUserLocale } from "@lib/i18n/utils-server";
import { cn } from "@lib/utils";
const localeCopy: Record<Locale, {
  ariaLabel: string;
  label: string;
  nextLocale: Locale;
}> = {
  ru: {
    ariaLabel: "Текущий язык: русский. Переключить на английский",
    label: "RU",
    nextLocale: "en"
  },
  en: {
    ariaLabel: "Current language: English. Switch to Russian",
    label: "EN",
    nextLocale: "ru"
  }
};
type SwitchLanguageButtonProps = PropsWithClassName & {
  locale: Locale;
};
export const SwitchLanguageButton: FC<SwitchLanguageButtonProps> = t0 => {
  const $ = _c(11);
  const {
    locale,
    className
  } = t0;
  const [isPending, startTransition] = useTransition();
  const copy = localeCopy[locale];
  let t1;
  if ($[0] !== copy.nextLocale) {
    t1 = () => {
      startTransition(() => {
        setUserLocale(copy.nextLocale).then();
      });
    };
    $[0] = copy.nextLocale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const changeLocale = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn(className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== changeLocale || $[5] !== copy.ariaLabel || $[6] !== copy.label || $[7] !== isPending || $[8] !== locale || $[9] !== t2) {
    t3 = <Button variant="outline" size="icon" className={t2} onClick={changeLocale} aria-label={copy.ariaLabel} title={copy.ariaLabel} data-current-locale={locale} disabled={isPending}>{copy.label}</Button>;
    $[4] = changeLocale;
    $[5] = copy.ariaLabel;
    $[6] = copy.label;
    $[7] = isPending;
    $[8] = locale;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};